import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';
import { getUnitById, isEpisodeActive } from './selectors';
import { getCurrentCommunity } from '../communities/selectors';
import { serialize } from './serializer';
import { groupBy, isEmpty, sortBy } from 'lodash';
import userActions from '../users/actions';
import { normalProfileTypes } from '../../constants/profileTypes';
import { contractStatus } from '../../constants/contracts';
const types = {
  queryRentedContractsInProgress: 'queryRentedContractsInProgress',
  queryRentedContractsSuccess: 'queryRentedContractsSuccess',
  queryRentedContractsFail: 'queryRentedContractsFail',
  queryMultipleUnitsSuccess: 'queryMultipleUnitsSuccess',
  queryMultipleUnitsInProgress: 'queryMultipleUnitsInProgress',
  queryMultipleUnitsFailed: 'queryMultipleUnitsFailed',
  queryUnitsSuccess: 'queryUnitsSuccess',
  queryUnitsInProgress: 'queryUnitsInProgress',
  queryUnitsFailed: 'queryUnitsFailed',
  findUnitByIdSuccess: 'findUnitByIdSuccess',
  findUnitByIdInProgress: 'findUnitByIdInProgress',
  findUnitByIdFailed: 'findUnitByIdFailed',
  updateUnitByIdSuccess: 'updateUnitByIdSuccess',
  updateUnitByIdInProgress: 'updateUnitByIdInProgress',
  updateUnitByIdFailed: 'updateUnitByIdFailed',
  deleteUnitByIdSuccess: 'deleteUnitByIdSuccess',
  deleteUnitByIdInProgress: 'deleteUnitByIdInProgress',
  deleteUnitByIdFailed: 'deleteUnitByIdFailed',
  createUnitSuccess: 'createUnitSuccess',
  createUnitInProgress: 'createUnitInProgress',
  createUnitFailed: 'createUnitFailed',
  setCurrentUnitCoordinates: 'setCurrentUnitCoordinates',
  findAccessLevelsInProgress: 'findAccessLevelsInProgress',
  findAccessLevelsSuccess: 'findAccessLevelsSuccess',
  findAccessLevelsFailed: 'findAccessLevelsFailed',
  findZoneAccessAssignmentsInProgress: 'findZoneAccessAssignmentsInProgress',
  findZoneAccessAssignmentsSuccess: 'findZoneAccessAssignmentsSuccess',
  findZoneAccessAssignmentsFailed: 'findZoneAccessAssignmentsFailed',
  updateZoneAccessAssignmentInProgress: 'updateZoneAccessAssignmentInProgress',
  updateZoneAccessAssignmentSuccess: 'updateZoneAccessAssignmentSuccess',
  updateZoneAccessAssignmentFailed: 'updateZoneAccessAssignmentFailed',
  updateZoneAccessAssignmentKeenvilSaved:
    'updateZoneAccessAssignmentKeenvilSaved',
  updateZoneAccessAssignmentRecofacialStatus:
    'updateZoneAccessAssignmentRecofacialStatus',
  clearZoneAccessAssignmentStatus: 'clearZoneAccessAssignmentStatus',
  findUnitAccessSuspensionsInProgress: 'findUnitAccessSuspensionsInProgress',
  findUnitAccessSuspensionsSuccess: 'findUnitAccessSuspensionsSuccess',
  findUnitAccessSuspensionsFailed: 'findUnitAccessSuspensionsFailed',
  updateAccessSuspensionInProgress: 'updateAccessSuspensionInProgress',
  updateAccessSuspensionSuccess: 'updateAccessSuspensionSuccess',
  updateAccessSuspensionFailed: 'updateAccessSuspensionFailed',
  updateAccessSuspensionKeenvilSaved: 'updateAccessSuspensionKeenvilSaved',
  updateAccessSuspensionRecofacialStatus:
    'updateAccessSuspensionRecofacialStatus',
  clearAccessSuspensionStatus: 'clearAccessSuspensionStatus'
};

const queryRentedContractsInProgress = createAction(
  types.queryRentedContractsInProgress
);
const queryRentedContractsSuccess = createAction(
  types.queryRentedContractsSuccess
);
const queryRentedContractsFail = createAction(types.queryRentedContractsFail);
const queryMultipleUnitsSuccess = createAction(types.queryMultipleUnitsSuccess);
const queryMultipleUnitsInProgress = createAction(
  types.queryMultipleUnitsInProgress
);
const queryMultipleUnitsFailed = createAction(types.queryMultipleUnitsFailed);
const queryUnitsSuccess = createAction(types.queryUnitsSuccess);
const queryUnitsInProgress = createAction(types.queryUnitsInProgress);
const queryUnitsFailed = createAction(types.queryUnitsFailed);
const findUnitByIdSuccess = createAction(types.findUnitByIdSuccess);
const findUnitByIdInProgress = createAction(types.findUnitByIdInProgress);
const findUnitByIdFailed = createAction(types.findUnitByIdFailed);
const updateUnitByIdSuccess = createAction(types.updateUnitByIdSuccess);
const updateUnitByIdInProgress = createAction(types.updateUnitByIdInProgress);
const updateUnitByIdFailed = createAction(types.updateUnitByIdFailed);
const deleteUnitByIdSuccess = createAction(types.deleteUnitByIdSuccess);
const deleteUnitByIdInProgress = createAction(types.deleteUnitByIdInProgress);
const deleteUnitByIdFailed = createAction(types.deleteUnitByIdFailed);
const createUnitSuccess = createAction(types.createUnitSuccess);
const createUnitInProgress = createAction(types.createUnitInProgress);
const createUnitFailed = createAction(types.createUnitFailed);
const setCurrentUnitCoordinates = createAction(types.setCurrentUnitCoordinates);
const findAccessLevelsInProgress = createAction(
  types.findAccessLevelsInProgress
);
const findAccessLevelsSuccess = createAction(types.findAccessLevelsSuccess);
const findAccessLevelsFailed = createAction(types.findAccessLevelsFailed);
const findZoneAccessAssignmentsInProgress = createAction(
  types.findZoneAccessAssignmentsInProgress
);
const findZoneAccessAssignmentsSuccess = createAction(
  types.findZoneAccessAssignmentsSuccess
);
const findZoneAccessAssignmentsFailed = createAction(
  types.findZoneAccessAssignmentsFailed
);
const updateZoneAccessAssignmentInProgress = createAction(
  types.updateZoneAccessAssignmentInProgress
);
const updateZoneAccessAssignmentSuccess = createAction(
  types.updateZoneAccessAssignmentSuccess
);
const updateZoneAccessAssignmentFailed = createAction(
  types.updateZoneAccessAssignmentFailed
);
// Two-indicator zone sync feedback (mirrors AccessCredentialsCard's
// keenvilSaved + dssSyncStatus pattern): Keenvil confirms immediately,
// independently of however long the RecoFacial (ZK) sync takes to settle.
const updateZoneAccessAssignmentKeenvilSaved = createAction(
  types.updateZoneAccessAssignmentKeenvilSaved
);
const updateZoneAccessAssignmentRecofacialStatus = createAction(
  types.updateZoneAccessAssignmentRecofacialStatus
);
const clearZoneAccessAssignmentStatusAction = createAction(
  types.clearZoneAccessAssignmentStatus
);

const findUnitAccessSuspensionsInProgress = createAction(
  types.findUnitAccessSuspensionsInProgress
);
const findUnitAccessSuspensionsSuccess = createAction(
  types.findUnitAccessSuspensionsSuccess
);
const findUnitAccessSuspensionsFailed = createAction(
  types.findUnitAccessSuspensionsFailed
);
const updateAccessSuspensionInProgress = createAction(
  types.updateAccessSuspensionInProgress
);
const updateAccessSuspensionSuccess = createAction(
  types.updateAccessSuspensionSuccess
);
const updateAccessSuspensionFailed = createAction(
  types.updateAccessSuspensionFailed
);
// Two-indicator feedback (same pattern as zones' ZoneSyncProgress):
// Keenvil confirms right away, Servidor de RecoFacial starts 'loading' and
// settles separately once the unit's ZK summary is polled.
const updateAccessSuspensionKeenvilSaved = createAction(
  types.updateAccessSuspensionKeenvilSaved
);
const updateAccessSuspensionRecofacialStatus = createAction(
  types.updateAccessSuspensionRecofacialStatus
);
const clearAccessSuspensionStatusAction = createAction(
  types.clearAccessSuspensionStatus
);

const setupCommunityModule = (getState, Api) => {
  const communityModule = Api.getModule('community');
  communityModule.adapter.token = getState().session.user.token;
  communityModule.adapter.communityId = getState().session.profile.community.id;
  return communityModule;
};

const dssSyncedStatuses = ['SYNCED', 'FROZEN'];
const isTestEnvironment = process.env.NODE_ENV === 'test';
const dssSyncPollIntervalMs = isTestEnvironment ? 10 : 1500;
const dssSyncTimeoutMs = isTestEnvironment ? 100 : 30000;
const dssSyncSuccessSettleMs = isTestEnvironment ? 30 : 4500;

const zkSyncPollIntervalMs = isTestEnvironment ? 10 : 2000;
const zkSyncPollTimeoutMs = isTestEnvironment ? 100 : 10000;
// Morosidad resyncs every member of the group, one by one, against all their communities
// (backend): in prod it took ~80 s for a support account in 15 communities. A 10 s window
// ended in "pendiente" although ZK did sync, so morosidad waits longer.
const accessSuspensionPollTimeoutMs = isTestEnvironment ? 100 : 90000;
const accessSuspensionPollIntervalMs = isTestEnvironment ? 10 : 3000;

// Each ZK summary poll takes a generation; a newer save or a status clear
// (screens call it on unmount / navigation) bumps it, which stops the older
// poll so no timer keeps running or dispatches a stale notice.
let zkSyncPollGeneration = 0;

const clearZoneAccessAssignmentStatus = () => dispatch => {
  zkSyncPollGeneration += 1;
  return dispatch(clearZoneAccessAssignmentStatusAction());
};

// Separate generation counter for the morosidad poll (own domain, own
// screen lifecycle) — same cancel-on-clear/cancel-on-new-save mechanics.
let accessSuspensionPollGeneration = 0;

const clearAccessSuspensionStatus = () => dispatch => {
  accessSuspensionPollGeneration += 1;
  return dispatch(clearAccessSuspensionStatusAction());
};

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Parses `lastAttemptedAt`/`lastSyncedAt` tolerantly: the backend may
 * serialize a Java `LocalDateTime` either as an ISO-8601 string or as a
 * Jackson array `[year, month, day, hour, minute, second, nano]` (months
 * are 1-based there, unlike JS `Date`). Returns a timestamp usable only to
 * detect "did this value change", never compared against the browser's
 * clock (that introduces clock-skew and was the root cause of the DSS
 * verification always timing out).
 */
const parseSyncTimestamp = value => {
  if (value == null) {
    return null;
  }

  if (Array.isArray(value)) {
    const [
      year,
      month,
      day,
      hour = 0,
      minute = 0,
      second = 0,
      nano = 0
    ] = value;

    if (year == null || month == null || day == null) {
      return null;
    }

    const timestamp = new Date(
      year,
      month - 1,
      day,
      hour,
      minute,
      second,
      Math.floor(nano / 1e6)
    ).getTime();

    return Number.isNaN(timestamp) ? null : timestamp;
  }

  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? null : timestamp;
};

const getSyncStatusTimestampKey = syncStatus => {
  const raw =
    (syncStatus && syncStatus.lastAttemptedAt) ||
    (syncStatus && syncStatus.lastSyncedAt);
  const parsed = parseSyncTimestamp(raw);
  // Fall back to the raw value (stringified) so that even if it can't be
  // parsed we can still detect that the backend reported a new attempt.
  return parsed != null ? parsed : raw ? JSON.stringify(raw) : null;
};

const createDssSyncError = syncStatus => ({
  apiErrors: [
    {
      message:
        syncStatus && syncStatus.syncError
          ? syncStatus.syncError
          : 'No se pudo aplicar la zona en DSS.'
    }
  ],
  dssSyncStatus: syncStatus
});

const createDssSyncUnavailableError = () => ({
  apiErrors: [
    {
      message: 'No se pudo verificar el estado en DSS.'
    }
  ],
  dssSyncStatus: {
    syncStatus: 'UNVERIFIED',
    syncError: 'No se pudo verificar el estado en DSS.'
  }
});

/**
 * Polls the DSS sync status for an individual until it settles.
 *
 * Resolves with `{ syncStatus, pending: false }` once the status is
 * SYNCED/FROZEN and has held for `dssSyncSuccessSettleMs`. Rejects only
 * when the backend reports an actual FAILED status. On timeout without a
 * confirmed FAILED, it resolves with `{ syncStatus, pending: true }` — the
 * change in Keenvil already happened, DSS just couldn't be confirmed in
 * time, so callers should show a soft warning, not a red error.
 */
const pollIndividualDssSyncStatus = (
  communityModule,
  communityId,
  individualId
) => {
  const pollingStartedAt = Date.now();
  let latestSyncStatus = null;
  let latestFailedStatus = null;
  let successSince = null;
  let successTimestampKey = null;

  const poll = () =>
    communityModule
      .findIndividualZoneAccessSyncStatus(communityId, individualId)
      .then(syncStatus => {
        latestSyncStatus = syncStatus;
        const status = syncStatus && syncStatus.syncStatus;

        if (dssSyncedStatuses.includes(status)) {
          const timestampKey = getSyncStatusTimestampKey(syncStatus);

          if (successTimestampKey !== timestampKey) {
            successTimestampKey = timestampKey;
            successSince = Date.now();
          }

          if (Date.now() - successSince >= dssSyncSuccessSettleMs) {
            return { syncStatus, pending: false };
          }
        } else {
          successSince = null;
          successTimestampKey = null;

          if (status === 'FAILED') {
            latestFailedStatus = syncStatus;
          }
        }

        if (Date.now() - pollingStartedAt >= dssSyncTimeoutMs) {
          if (latestFailedStatus) {
            return Promise.reject(createDssSyncError(latestFailedStatus));
          }

          return { syncStatus: latestSyncStatus, pending: true };
        }

        return wait(dssSyncPollIntervalMs).then(poll);
      })
      .catch(error => {
        if (error && error.dssSyncStatus) {
          return Promise.reject(error);
        }

        return Promise.reject(createDssSyncUnavailableError());
      });

  return poll();
};

const isZkOnlyCommunity = state =>
  Boolean(state.communities && state.communities.zkEnabled) &&
  !(state.communities && state.communities.dssEnabled);

const shouldSyncZoneAccessAssignment = assignment =>
  assignment.subjectType === 'INDIVIDUAL' && assignment.subjectId != null;

const replaceSubjectAssignments = (
  assignments,
  subjectType,
  subjectId,
  freshRows
) => {
  const stringId = `${subjectId}`;
  const untouched = (assignments || []).filter(
    existing =>
      !(
        existing.subjectType === subjectType &&
        `${existing.subjectId}` === stringId
      )
  );

  return [...untouched, ...(freshRows || [])];
};

/**
 * Refreshes only the mutated subject's rows in `state.units.zoneAccessAssignments`
 * (merged with whatever else was already loaded) instead of re-fetching the
 * entire community — keeps fix #2's scoped loading intact after a
 * save/delete instead of clobbering it with the unfiltered endpoint.
 */
const refreshZoneAccessAssignmentsForSubject = (subjectType, subjectId) => {
  return (dispatch, getState, Api) => {
    const communityModule = setupCommunityModule(getState, Api);
    const communityId = getState().session.profile.community.id;

    return communityModule
      .findZoneAccessAssignmentsForSubject(communityId, subjectType, subjectId)
      .then(freshRows => {
        const merged = replaceSubjectAssignments(
          getState().units.zoneAccessAssignments,
          subjectType,
          subjectId,
          freshRows
        );
        dispatch(findZoneAccessAssignmentsSuccess(merged));
        return merged;
      });
  };
};

const zkServerLabel = 'Servidor de RecoFacial';

const pollUntilSettled = (
  isCancelled,
  fetchStatus,
  isSettled,
  startedAt,
  { timeoutMs = zkSyncPollTimeoutMs, intervalMs = zkSyncPollIntervalMs } = {}
) => {
  const poll = () =>
    fetchStatus()
      .catch(() => null)
      .then(status => {
        if (isCancelled()) {
          return null;
        }

        if (isSettled(status) || Date.now() - startedAt >= timeoutMs) {
          return status;
        }

        return wait(intervalMs).then(poll);
      });

  return poll();
};

/**
 * ZK syncs asynchronously after the commit. Two independent indicators
 * (mirrors AccessCredentialsCard's keenvilSaved + dssSyncStatus):
 *  - Keenvil: dispatched right here, since `response` only exists once the
 *    POST/DELETE to our own DB already succeeded — doesn't wait for ZK.
 *  - Servidor de RecoFacial: starts 'loading' and polls for the real
 *    outcome every ~2s up to ~10s.
 *    - UNIT subjects poll `.../units/{id}/summary?provider=ZK`.
 *    - INDIVIDUAL subjects poll the per-individual status endpoint with
 *      `?provider=ZK`.
 *    - COMMUNITY subjects have no status endpoint yet (ask Pablo): stays
 *      'loading' with an explicit note instead of guessing an outcome.
 *   For UNIT/INDIVIDUAL, once polling ends:
 *    - the real thing settled (allSynced / SYNCED)        → 'synced'.
 *    - the status/summary call answered but didn't settle
 *      (pending/failed preexistentes, or just ran out of the ~10s window
 *      with a real response — many units carry residents permanently
 *      FAILED/notSynced from old data, so this is common and NOT an
 *      error) → 'pending' (yellow, not red).
 *    - the status/summary call itself never returned a response (fetch
 *      threw, caught to null)                              → 'error' (red).
 */
const finishZkZoneAccessSync = (
  dispatch,
  communityModule,
  communityId,
  assignment,
  response,
  message
) => {
  const generation = (zkSyncPollGeneration += 1);

  dispatch(updateZoneAccessAssignmentKeenvilSaved({ message }));

  if (assignment.subjectId == null) {
    return Promise.resolve(response);
  }

  const isCancelled = () => generation !== zkSyncPollGeneration;
  const startedAt = Date.now();
  const dispatchRecofacialStatus = (status, statusMessage) => {
    if (isCancelled()) {
      return;
    }

    dispatch(
      updateZoneAccessAssignmentRecofacialStatus({
        status,
        message: statusMessage
      })
    );
  };

  if (assignment.subjectType === 'UNIT') {
    const isSettled = summary => Boolean(summary && summary.allSynced);

    return pollUntilSettled(
      isCancelled,
      () =>
        communityModule.findUnitZoneAccessSyncSummary(
          communityId,
          assignment.subjectId,
          'ZK'
        ),
      isSettled,
      startedAt
    ).then(summary => {
      if (summary && summary.allSynced) {
        dispatchRecofacialStatus(
          'synced',
          `Aplicado en el ${zkServerLabel} (${summary.synced}/${summary.total})`
        );
      } else if (summary) {
        // El summary respondió (no es un error de red/backend): hay
        // pending/failed preexistentes que no tienen que ver con este
        // cambio puntual, o simplemente no terminó en la ventana de
        // polling. No es un error.
        dispatchRecofacialStatus(
          'pending',
          'Sincronización pendiente · revisá el estado más tarde'
        );
      } else {
        dispatchRecofacialStatus(
          'error',
          `No se pudo consultar el ${zkServerLabel}`
        );
      }

      return response;
    });
  }

  if (assignment.subjectType === 'INDIVIDUAL') {
    const isSettled = status =>
      Boolean(status && status.syncStatus === 'SYNCED');

    return pollUntilSettled(
      isCancelled,
      () =>
        communityModule.findIndividualZoneAccessSyncStatus(
          communityId,
          assignment.subjectId,
          'ZK'
        ),
      isSettled,
      startedAt
    ).then(status => {
      if (status && status.syncStatus === 'SYNCED') {
        dispatchRecofacialStatus('synced', `Aplicado en el ${zkServerLabel}`);
      } else if (status) {
        dispatchRecofacialStatus(
          'pending',
          'Sincronización pendiente · revisá el estado más tarde'
        );
      } else {
        dispatchRecofacialStatus(
          'error',
          `No se pudo consultar el ${zkServerLabel}`
        );
      }

      return response;
    });
  }

  // COMMUNITY: no hay endpoint de estado por comunidad todavía — se queda
  // en 'loading' con una nota, en vez de inventar un resultado.
  dispatchRecofacialStatus(
    'loading',
    `Sin verificación disponible para zonas de comunidad en el ${zkServerLabel} todavía`
  );
  return Promise.resolve(response);
};

/**
 * Dispatches the Keenvil-only success first, then (for individual subjects)
 * triggers + polls the DSS sync and dispatches the final outcome:
 *  - settled SYNCED/FROZEN → success, "Aplicada en DSS ✓"
 *  - timeout without a real failure → success with `pending: true` (soft
 *    warning, not an error — the change in Keenvil is real, DSS just
 *    couldn't be confirmed in time). See fix #1 in castleblack-fixes-zonas-dss.md.
 *  - confirmed FAILED → failed dispatch with the real DSS error
 * In the uncertain/failed cases it re-fetches the assignments (fix #5) so
 * the list still reflects DB truth even if the DSS confirmation didn't land.
 *
 * Does NOT trigger a manual `POST zoneaccess/sync/...` before polling: the
 * backend already auto-resyncs to DSS on assignment change
 * (ZoneAccessResyncService). Triggering a second, manual sync here raced
 * against that automatic one and made DSS return an intermittent
 * 502/FAILED on the concurrent request — which the poll then reported as
 * a real error even though the (single, backend-triggered) sync had
 * actually applied fine. Only poll the status here, never re-trigger it.
 */
const finishZoneAccessSync = (
  dispatch,
  communityModule,
  communityId,
  assignment,
  response,
  message,
  zkOnly = false
) => {
  if (zkOnly) {
    return finishZkZoneAccessSync(
      dispatch,
      communityModule,
      communityId,
      assignment,
      response,
      message
    );
  }

  if (!shouldSyncZoneAccessAssignment(assignment)) {
    dispatch(
      updateZoneAccessAssignmentSuccess({ assignment: response, message })
    );
    return Promise.resolve(response);
  }

  return pollIndividualDssSyncStatus(
    communityModule,
    communityId,
    assignment.subjectId
  )
    .then(result => {
      if (result.pending) {
        dispatch(
          refreshZoneAccessAssignmentsForSubject(
            assignment.subjectType,
            assignment.subjectId
          )
        ).catch(() => {});
      }

      dispatch(
        updateZoneAccessAssignmentSuccess({
          assignment: response,
          message: result.pending
            ? `${message} · Aplicación en DSS pendiente de confirmar`
            : `${message} · Aplicada en DSS ✓`,
          pending: result.pending
        })
      );
      return response;
    })
    .catch(error => {
      dispatch(
        refreshZoneAccessAssignmentsForSubject(
          assignment.subjectType,
          assignment.subjectId
        )
      ).catch(() => {});

      dispatch(
        updateZoneAccessAssignmentFailed({
          apiError: [
            {
              message: `${message} · No se pudo aplicar en DSS: ${
                error.apiErrors && error.apiErrors[0]
                  ? error.apiErrors[0].message
                  : 'No se pudo verificar el estado en DSS.'
              }`
            }
          ]
        })
      );
      return Promise.reject({
        ...error,
        zoneAccessSyncHandled: true
      });
    });
};

/**
 * Morosidad (access suspensions) — spec `spec-front-morosidad-castleblack.md`.
 * One GET by unit gives everything the UI needs: whether the UF is "EN
 * MORA" (some episode with `liftedAt === null` and `subjectType ===
 * 'GROUP'`) and, per contract, its own suspension history (filtering by
 * `episode.subjectId === contract.individualGroupId`).
 */
const findUnitAccessSuspensions = unitId => {
  return (dispatch, getState, Api) => {
    dispatch(findUnitAccessSuspensionsInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .findUnitAccessSuspensions(unitId)
      .then(response => {
        dispatch(findUnitAccessSuspensionsSuccess(response || []));
        return response || [];
      })
      .catch(error => {
        dispatch(
          findUnitAccessSuspensionsFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

/**
 * Two-indicator feedback for morosidad, same pattern/semantics as zones'
 * UNIT branch: Keenvil confirms immediately (the save already happened by
 * the time this runs); Servidor de RecoFacial starts 'loading' and polls
 * the unit's ZK summary every ~2s up to ~10s:
 *  - allSynced                    → 'synced' (verde).
 *  - summary respondió pero no allSynced (pending/failed preexistentes, o
 *    se acabó la ventana con una respuesta real) → 'pending' (amarillo,
 *    NO es un error — el episodio quedó guardado, el reconcile lo aplica
 *    cuando ZK vuelva a resolver).
 *  - el fetch del summary nunca respondió → 'error' (rojo).
 */
const accessSuspensionRetryHint =
  'Si los residentes no logran acceder, revisá la conexión de los dispositivos y sincronizalos individualmente.';

const finishAccessSuspensionSync = (
  dispatch,
  communityModule,
  communityId,
  unitId,
  message,
  hasZkIntegration
) => {
  const generation = (accessSuspensionPollGeneration += 1);

  dispatch(updateAccessSuspensionKeenvilSaved({ message }));

  // Communities without ZK use morosidad as a visual/communication tool only:
  // there is no RecoFacial server to report on, so only the Keenvil indicator shows.
  if (!hasZkIntegration) {
    dispatch(
      updateAccessSuspensionRecofacialStatus({ status: 'none', message: null })
    );
    return Promise.resolve();
  }

  dispatch(
    updateAccessSuspensionRecofacialStatus({
      status: 'loading',
      message: `Sincronizando con el ${zkServerLabel}… puede tardar hasta un minuto`
    })
  );

  const isCancelled = () => generation !== accessSuspensionPollGeneration;
  const startedAt = Date.now();
  // Done when nobody is left PENDING (the back marks the whole group PENDING before
  // queueing the re-sync). Waiting for allSynced never ended when someone in the group
  // fails in ZK for reasons unrelated to this change (rejected photo, no zones), so the
  // front sat the full window and showed "pendiente" although ZK had finished.
  const isSettled = summary =>
    Boolean(summary && (summary.allSynced || summary.pending === 0));

  return pollUntilSettled(
    isCancelled,
    () =>
      communityModule.findUnitZoneAccessSyncSummary(communityId, unitId, 'ZK'),
    isSettled,
    startedAt,
    {
      timeoutMs: accessSuspensionPollTimeoutMs,
      intervalMs: accessSuspensionPollIntervalMs
    }
  ).then(summary => {
    if (isCancelled()) {
      return;
    }

    dispatch(
      updateAccessSuspensionRecofacialStatus(
        accessSuspensionRecofacialResult(summary)
      )
    );
  });
};

// Text of the RecoFacial indicator once the poll ends (exported for tests).
export const accessSuspensionRecofacialResult = summary => {
  if (!summary) {
    return {
      status: 'error',
      message: `No se pudo consultar el ${zkServerLabel}. ${accessSuspensionRetryHint}`
    };
  }
  if (summary.allSynced) {
    return {
      status: 'synced',
      message: `Aplicado en el ${zkServerLabel} (${summary.synced}/${summary.total})`
    };
  }
  if (summary.pending === 0) {
    const withIssues = (summary.failed || 0) + (summary.notSynced || 0);
    return {
      status: 'pending',
      message: `Aplicado en el ${zkServerLabel} a ${summary.synced} de ${summary.total} personas. ${withIssues} con observaciones en ZK (por ejemplo, foto rechazada): revisalas desde el perfil de cada persona.`
    };
  }
  return {
    status: 'pending',
    message: `Sincronización pendiente. ${accessSuspensionRetryHint}`
  };
};

// A second click (or double click) while an apply/lift is running is ignored: it used to
// send the operation twice and the second one failed (e.g. 404 lifting an already lifted
// episode), showing an error although the first one had worked.
const isAccessSuspensionBusy = getState =>
  Boolean(getState().units && getState().units.accessSuspensionInProgress);

const isNotFoundError = error =>
  Boolean(
    error &&
      error.apiErrors &&
      error.apiErrors.some(item => item && item.httpStatus === 404)
  );

const applyUnitAccessSuspension = ({ unitId, individualGroupId, reason }) => {
  return (dispatch, getState, Api) => {
    if (isAccessSuspensionBusy(getState)) {
      return Promise.resolve();
    }
    dispatch(updateAccessSuspensionInProgress());

    const communityModule = setupCommunityModule(getState, Api);
    const communityId = getState().session.profile.community.id;

    return communityModule
      .applyAccessSuspension({
        subjectType: 'GROUP',
        subjectId: individualGroupId,
        unitId,
        reason
      })
      .then(response =>
        // Esperar el refetch (no fire-and-forget) antes de arrancar el
        // polling de recofacial: el badge/botón/tarjetas tienen que
        // recalcularse desde el episodio activo real, no quedar stale.
        dispatch(findUnitAccessSuspensions(unitId))
          .catch(() => {})
          .then(() =>
            finishAccessSuspensionSync(
              dispatch,
              communityModule,
              communityId,
              unitId,
              'Morosidad aplicada en Keenvil',
              Boolean(getCurrentCommunity(getState()).zkEnabled)
            )
          )
          .then(() => response)
      )
      .catch(error => {
        dispatch(
          updateAccessSuspensionFailed({
            apiError: error.apiErrors || [
              {
                message: 'No se pudo aplicar la morosidad. Intente nuevamente.'
              }
            ]
          })
        );
        return Promise.reject(error);
      });
  };
};

/**
 * Levanta el episodio GROUP activo de la unidad. No usa el subjectId que
 * le pasó el llamador (podía quedar stale entre el último render y el
 * click, lo que terminaba en un 404 del back al apuntar a un episodio que
 * ya no era el vigente) — relee el episodio activo del store en el momento
 * mismo del dispatch, que es la fuente más fresca posible.
 */
const liftUnitAccessSuspension = ({ unitId }) => {
  return (dispatch, getState, Api) => {
    if (isAccessSuspensionBusy(getState)) {
      return Promise.resolve();
    }
    dispatch(updateAccessSuspensionInProgress());

    const communityModule = setupCommunityModule(getState, Api);
    const communityId = getState().session.profile.community.id;

    // Trae el episodio activo DE NUEVO, recién — nunca el de un render
    // anterior ni el que ya estaba en el store antes de este click, que
    // podía quedar stale y apuntar a un episodio que el back ya no
    // reconocía (el 404 "No se pudo levantar").
    return dispatch(findUnitAccessSuspensions(unitId))
      .then(freshEpisodes => {
        const activeEpisode = (freshEpisodes || []).find(
          episode => isEpisodeActive(episode) && episode.subjectType === 'GROUP'
        );

        if (!activeEpisode) {
          const apiError = [
            { message: 'No hay una morosidad activa para levantar.' }
          ];
          dispatch(updateAccessSuspensionFailed({ apiError }));
          return Promise.reject({ apiErrors: apiError });
        }

        return communityModule
          .liftAccessSuspension({
            subjectType: activeEpisode.subjectType,
            subjectId: activeEpisode.subjectId
          })
          .then(response =>
            dispatch(findUnitAccessSuspensions(unitId))
              .catch(() => {})
              .then(() =>
                finishAccessSuspensionSync(
                  dispatch,
                  communityModule,
                  communityId,
                  unitId,
                  'Morosidad levantada en Keenvil',
                  Boolean(getCurrentCommunity(getState()).zkEnabled)
                )
              )
              .then(() => response)
          );
      })
      .catch(error => {
        // 404 = the episode was already lifted (another tab/admin, or a previous click):
        // the desired state is reached, so it is not shown as an error.
        if (isNotFoundError(error)) {
          dispatch(findUnitAccessSuspensions(unitId)).catch(() => {});
          dispatch(
            updateAccessSuspensionKeenvilSaved({
              message: 'La morosidad ya estaba levantada'
            })
          );
          dispatch(
            updateAccessSuspensionRecofacialStatus({
              status: 'none',
              message: null
            })
          );
          return undefined;
        }
        // Resincroniza igual ante un error para que el badge/botón no queden stale.
        dispatch(findUnitAccessSuspensions(unitId)).catch(() => {});
        dispatch(
          updateAccessSuspensionFailed({
            apiError: error.apiErrors || [
              {
                message: 'No se pudo levantar la morosidad. Intente nuevamente.'
              }
            ]
          })
        );
        return Promise.reject(error);
      });
  };
};

/**
 *
 * @param {Object} query query filter object.
 *                 Contains q, page, limit, and sort.
 *                 All optionals.
 */
const queryUnits = query => {
  return (dispatch, getState, Api) => {
    dispatch(queryUnitsInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .queryUnits(query)
      .then(response => {
        dispatch(queryUnitsSuccess(response));
        return Promise.resolve(response);
      })
      .catch(error => {
        dispatch(
          queryUnitsFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

const searchUnits = () => {
  return (dispatch, getState, Api) => {
    dispatch(queryUnitsInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    return {
      action: query => communityModule.queryUnits(query)
    };
  };
};

const findMultipleUnitsByIds = (
  ids,
  contractsArray,
  userToCompleteProfiles
) => {
  return (dispatch, getState, Api) => {
    dispatch(queryUnitsInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .queryMultipleUnits(ids, contractsArray.length)
      .then(units => {
        if (isEmpty(userToCompleteProfiles)) {
          let i;
          let unitContractsList = [];
          for (i = 0; i < contractsArray.length; i++) {
            const unit = units.find(
              unit => unit.id === contractsArray[i].unitId
            );
            if (unit) {
              unitContractsList.push({
                ...unit,
                contracts: [contractsArray[i]]
              });
            }
          }

          dispatch(queryMultipleUnitsSuccess(unitContractsList));
        } else {
          const normalProfiles = userToCompleteProfiles.profiles.filter(
            profile => !isEmpty(normalProfileTypes[profile.type])
          );
          const nonNormalProfile = userToCompleteProfiles.profiles.filter(
            profile => isEmpty(normalProfileTypes[profile.type])
          );

          const completedProfiles = normalProfiles.map(profile => ({
            ...profile,
            unit: units.find(unit => unit.id === profile.unit.id)
          }));

          dispatch(
            userActions.findUserByIdSuccess({
              ...userToCompleteProfiles,
              profiles: [...completedProfiles, ...nonNormalProfile]
            })
          );
        }
      })
      .catch(error => {
        dispatch(
          queryMultipleUnitsFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const queryRentedUnits = query => {
  return (dispatch, getState, Api) => {
    dispatch(queryUnitsInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .getContracts(query)
      .then(contracts => {
        dispatch(queryRentedContractsSuccess(contracts));
        if (contracts.content.length) {
          dispatch(
            findMultipleUnitsByIds(
              contracts.content.map(contract => contract.unitId),
              contracts.content
            )
          );
        } else {
          dispatch(queryMultipleUnitsSuccess([]));
        }
      })
      .catch(err => {});
  };
};

const findUnitById = id => {
  return (dispatch, getState, Api) => {
    dispatch(findUnitByIdInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .findUnitById(id)
      .then(response => {
        const groupedContracts = groupBy(response.contracts, 'status'); //'REVOKED','EXPIRED','CREATED','VALID

        const manualSortedContracts = [];
        if (groupedContracts[contractStatus.VALID]) {
          manualSortedContracts.push(...groupedContracts[contractStatus.VALID]);
        }
        if (groupedContracts[contractStatus.CREATED]) {
          manualSortedContracts.push(
            ...groupedContracts[contractStatus.CREATED]
          );
        }
        if (groupedContracts[contractStatus.EXPIRED]) {
          manualSortedContracts.push(
            ...groupedContracts[contractStatus.EXPIRED]
          );
        }
        if (groupedContracts[contractStatus.REVOKED]) {
          manualSortedContracts.push(
            ...groupedContracts[contractStatus.REVOKED]
          );
        }
        const unit = {
          ...response,
          contracts: manualSortedContracts
        };
        dispatch(findUnitByIdSuccess(unit));
      })
      .catch(error => {
        dispatch(
          findUnitByIdFailed({
            apiError: error.apiErrors,
            error
          })
        );
      });
  };
};

const updateUnitById = unit => {
  return (dispatch, getState, Api) => {
    dispatch(updateUnitByIdInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    const serializedUnit = serialize(
      unit,
      getState().units.updatedCurrentUnitCoordinates,
      getState().session.profile.community.id
    );

    return communityModule
      .updateUnitById(serializedUnit)
      .then(response => {
        dispatch(updateUnitByIdSuccess(response));
        dispatch(push('/units'));
      })
      .catch(error => {
        dispatch(
          updateUnitByIdFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const deleteUnitById = unit => {
  return (dispatch, getState, Api) => {
    dispatch(deleteUnitByIdInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .deleteUnitById(unit)
      .then(response => {
        dispatch(deleteUnitByIdSuccess(response));
        dispatch(push('/units'));
      })
      .catch(error => {
        dispatch(
          deleteUnitByIdFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const createUnit = unit => {
  return (dispatch, getState, Api) => {
    dispatch(createUnitInProgress());

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .createUnit(unit)
      .then(response => {
        dispatch(createUnitSuccess(response));
        dispatch(queryUnits({ page: 0, limit: 15 }));
        return Promise.resolve();
      })
      .catch(error => {
        dispatch(
          createUnitFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject();
      });
  };
};

// Etiqueta visible al usuario; el valor interno de `provider` no cambia.
const providerLabels = { DSS: 'DSS', ZK: 'Servidor de RecoFacial' };

const withProvider = (levels, provider, labelProvider) =>
  (levels || []).map(level => {
    const id = level.id != null ? level.id : level.externalId;

    return {
      ...level,
      id,
      provider,
      name: labelProvider
        ? `${providerLabels[provider]} — ${level.name}`
        : level.name
    };
  });

/**
 * Loads the access levels from whichever provider(s) the current community
 * has enabled (DSS and/or ZK) and normalizes them to `[{ id, name, provider }]`.
 * When both are enabled the name is prefixed with the provider ("DSS — x").
 * With neither flag set it keeps the historical behavior (DSS endpoint).
 */
const findAccessLevels = () => {
  return (dispatch, getState, Api) => {
    dispatch(findAccessLevelsInProgress());

    const communityModule = setupCommunityModule(getState, Api);
    const communityId = getState().session.profile.community.id;
    const { dssEnabled, zkEnabled } = getState().communities || {};
    const bothEnabled = Boolean(dssEnabled && zkEnabled);
    const loadDss = dssEnabled || !zkEnabled;

    return Promise.all([
      loadDss
        ? communityModule
            .findAccessLevels()
            .then(levels => withProvider(levels, 'DSS', bothEnabled))
        : Promise.resolve([]),
      zkEnabled
        ? communityModule
            .findZkAccessLevels(communityId)
            .then(levels => withProvider(levels, 'ZK', bothEnabled))
        : Promise.resolve([])
    ])
      .then(([dssLevels, zkLevels]) => {
        const levels = [...dssLevels, ...zkLevels];
        dispatch(findAccessLevelsSuccess(levels));
        return Promise.resolve(levels);
      })
      .catch(error => {
        dispatch(
          findAccessLevelsFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

const findZoneAccessAssignments = () => {
  return (dispatch, getState, Api) => {
    dispatch(findZoneAccessAssignmentsInProgress());

    const communityModule = setupCommunityModule(getState, Api);
    const communityId = getState().session.profile.community.id;

    return communityModule
      .findZoneAccessAssignments(communityId)
      .then(response => {
        dispatch(findZoneAccessAssignmentsSuccess(response || []));
        return Promise.resolve(response || []);
      })
      .catch(error => {
        dispatch(
          findZoneAccessAssignmentsFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

const dedupeSubjects = subjects =>
  (subjects || []).reduce((unique, subject) => {
    const subjectType = subject && subject.subjectType;
    const subjectId = subject && subject.subjectId;
    const includeInherited = Boolean(subject && subject.includeInherited);

    if (subjectType == null || subjectId == null) {
      return unique;
    }

    const key = `${subjectType}:${subjectId}`;
    if (unique.some(item => item.key === key)) {
      return unique;
    }

    return [...unique, { key, subjectType, subjectId, includeInherited }];
  }, []);

/**
 * Zone assignments for a specific set of (subjectType, subjectId) pairs
 * instead of the whole community's assignment table.
 * `findZoneAccessAssignments` above hits
 * `GET zoneaccess/assignments?communityId=` unfiltered, which doesn't
 * scale (500 units / 3000 users) and goes stale fast on a busy community.
 * See fix #2 in castleblack-fixes-zonas-dss.md.
 */
const findScopedZoneAccessAssignments = subjects => {
  return (dispatch, getState, Api) => {
    dispatch(findZoneAccessAssignmentsInProgress());

    const communityModule = setupCommunityModule(getState, Api);
    const communityId = getState().session.profile.community.id;
    const uniqueSubjects = dedupeSubjects(subjects);

    const requests = uniqueSubjects.map(
      ({ subjectType, subjectId, includeInherited }) =>
        communityModule.findZoneAccessAssignmentsForSubject(
          communityId,
          subjectType,
          subjectId,
          includeInherited
        )
    );

    return Promise.all(requests)
      .then(responses => {
        const assignments = responses.reduce(
          (all, response) => all.concat(response || []),
          []
        );
        dispatch(findZoneAccessAssignmentsSuccess(assignments));
        return assignments;
      })
      .catch(error => {
        dispatch(
          findZoneAccessAssignmentsFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

/**
 * Zone assignments for a single individual, plus the unit(s) they belong
 * to (so inherited zones still resolve) — used by the user detail page.
 */
const findIndividualZoneAccessAssignments = (individualId, unitIds = []) =>
  findScopedZoneAccessAssignments([
    // includeInherited=true trae, en la misma llamada, las zonas heredadas
    // de COMUNIDAD (inherited:true, source:'COMMUNITY') además de los
    // overrides individuales. Solo aplica a esta vista de usuario, no a
    // findUnitZoneAccessAssignments.
    {
      subjectType: 'INDIVIDUAL',
      subjectId: individualId,
      includeInherited: true
    },
    ...(unitIds || []).map(unitId => ({
      subjectType: 'UNIT',
      subjectId: unitId
    }))
  ]);

/**
 * Zone assignments for a unit, plus each of its residents (so the unit
 * page can show every resident's individual overrides) — used by the unit
 * detail page instead of the unfiltered community-wide fetch.
 */
const findUnitZoneAccessAssignments = (unitId, residentIds = []) =>
  findScopedZoneAccessAssignments([
    { subjectType: 'UNIT', subjectId: unitId },
    ...(residentIds || []).map(individualId => ({
      subjectType: 'INDIVIDUAL',
      subjectId: individualId
    }))
  ]);

const saveZoneAccessAssignment = assignment => {
  return (dispatch, getState, Api) => {
    dispatch(updateZoneAccessAssignmentInProgress());

    const communityModule = setupCommunityModule(getState, Api);
    const communityId = getState().session.profile.community.id;
    const payload = {
      communityId,
      accessLevelId: assignment.accessLevelId,
      provider: assignment.provider,
      subjectType: assignment.subjectType,
      subjectId:
        assignment.subjectType === 'COMMUNITY' ? null : assignment.subjectId,
      mode: assignment.mode
    };
    const message =
      assignment.mode === 'REVOKE'
        ? 'Zona revocada en Keenvil ✓'
        : 'Zona permitida en Keenvil ✓';

    return communityModule
      .createZoneAccessAssignment(payload)
      .then(response => {
        return dispatch(
          refreshZoneAccessAssignmentsForSubject(
            assignment.subjectType,
            assignment.subjectId
          )
        ).then(() =>
          finishZoneAccessSync(
            dispatch,
            communityModule,
            communityId,
            assignment,
            response,
            message,
            isZkOnlyCommunity(getState())
          )
        );
      })
      .catch(error => {
        if (error && error.zoneAccessSyncHandled) {
          return Promise.reject(error);
        }

        dispatch(
          updateZoneAccessAssignmentFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

const getZoneAccessAssignmentId = assignment =>
  assignment && typeof assignment === 'object'
    ? assignment.id || assignment.assignmentId
    : assignment;

const deleteZoneAccessAssignment = assignment => {
  return (dispatch, getState, Api) => {
    dispatch(updateZoneAccessAssignmentInProgress());

    const assignmentId = getZoneAccessAssignmentId(assignment);
    const communityId = getState().session.profile.community.id;
    const message =
      assignment && assignment.mode === 'REVOKE'
        ? 'Herencia restaurada en Keenvil ✓'
        : 'Zona quitada en Keenvil ✓';

    if (!assignmentId) {
      const apiErrors = [{ message: 'No se encontró la asignación a quitar.' }];
      dispatch(
        updateZoneAccessAssignmentFailed({
          apiError: apiErrors
        })
      );
      return Promise.reject({ apiErrors });
    }

    const communityModule = setupCommunityModule(getState, Api);

    return communityModule
      .deleteZoneAccessAssignment(assignmentId)
      .then(response => {
        return dispatch(
          refreshZoneAccessAssignmentsForSubject(
            assignment.subjectType,
            assignment.subjectId
          )
        ).then(() =>
          finishZoneAccessSync(
            dispatch,
            communityModule,
            communityId,
            assignment,
            response,
            message,
            isZkOnlyCommunity(getState())
          )
        );
      })
      .catch(error => {
        if (error && error.zoneAccessSyncHandled) {
          return Promise.reject(error);
        }

        dispatch(
          updateZoneAccessAssignmentFailed({
            apiError: error.apiErrors
          })
        );
        return Promise.reject(error);
      });
  };
};

export { types };
export default {
  queryUnits,
  findUnitById,
  updateUnitById,
  deleteUnitById,
  createUnit,
  setCurrentUnitCoordinates,
  queryRentedUnits,
  findMultipleUnitsByIds,
  searchUnits,
  findAccessLevels,
  findZoneAccessAssignments,
  findIndividualZoneAccessAssignments,
  findUnitZoneAccessAssignments,
  saveZoneAccessAssignment,
  deleteZoneAccessAssignment,
  clearZoneAccessAssignmentStatus,
  findUnitAccessSuspensions,
  applyUnitAccessSuspension,
  liftUnitAccessSuspension,
  clearAccessSuspensionStatus
};
